// Prefer the native share sheet (mobile); fall back to copying the link.
// Returns 'shared' | 'cancelled' | 'copied' | 'failed'.
export async function shareLink(title, url) {
  if (navigator.share) {
    try {
      await navigator.share({ title, url });
      return 'shared';
    } catch (e) {
      if (e.name === 'AbortError') return 'cancelled';
      // NotAllowedError etc. — fall through to clipboard
    }
  }
  return (await copyText(url)) ? 'copied' : 'failed';
}

// navigator.clipboard is only available in secure contexts and can still
// reject (e.g. document not focused); fall back to a hidden textarea.
export async function copyText(text) {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (_) { /* fall through */ }
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try { ok = document.execCommand('copy'); } catch (_) { ok = false; }
  document.body.removeChild(ta);
  return ok;
}
